<template>
  <input
    type="checkbox"
    :class="color"
    class="border-none checked:bg-ontick-blue-600"
    v-model="checked"
  />
</template>

<script>
export default {
  name: "ontick-switch",
  data() {
    return {
      checked: false,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
    color: {
      type: String,
      default: "bg-ontick-carbon-500",
    },
  },
  computed: {
    checkboxActive() {
      return this.active;
    },
  },
  created() {
    this.checked = this.checkboxActive;
  },
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  position: relative;
  width: 40px;
  height: 20px;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 20px;
  box-shadow: inset 0 0 5px var(--ontick-switch-opacity);
  transition: background 300ms linear;
}

input:checked[type="checkbox"] {
  // background-image: url("");
}

input[type="checkbox"]::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  top: 0;
  left: 0;
  background: #fff;
  transform: scale(1.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: left 300ms linear;
}

input:checked[type="checkbox"]::before {
  left: 20px;
}
</style>
